export default __webpack_public_path__ + "static/media/flag-estonia.73fab3ac.svg";